import LegalDoc from "@/components/LegalDoc";
import { CUSTOMER_TOS } from "@/legal/customer-tos";

export default function TermsPlanner() {
  return (
    <LegalDoc
      doc={CUSTOMER_TOS}
      related={[
        { to: "/terms/vendor", label: "Vendor Terms of Service" },
      ]}
    />
  );
}
